import React from "react";
import { connect } from "react-redux";
import { any, func } from "prop-types";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import HorizontalLine from "../../common/HorizontalLine";
import { postWoodlandForms } from "../../redux/actions/woodlandActions";

const SiteRules = ({ appData, postWoodlandFormsFunc }) => {
  const initialState = {
    blurb1: {
      htmlObj: <HorizontalLine text={"Section 1 - Site Rules"} />,
    },
    sr1: {
      type: "singlecheckbox",
      title:
        "I understand and have a good knowledge on all signage that is in the warehouse.",
      mandatory: true,
    },
    sr2: {
      type: "singlecheckbox",
      title:
        "I understand that a hi visibility vest & safety footwear must be worn in the warehouse at all times. (Safety gloves are also made available due to the nature of some of the freight unloaded)",
      mandatory: true,
    },
    sr3: {
      type: "singlecheckbox",
      title:
        "I understand that the use of personal music systems i.e. MP3 players, iPods, and mobile phone devices are prohibited in the warehouse.",
      mandatory: true,
    },
    sr4: {
      type: "singlecheckbox",
      title: "I have been shown and read and understood the site rules.",
      mandatory: true,
    },
    sr5: {
      type: "singlecheckbox",
      title:
        "I undertake to continually review my working environment, should I see or be asked to undertake a task that represents a risk, I will stop what I am doing and raise the issue with my line manager who will advise on the way forward.",
      mandatory: true,
    },
    sr6: {
      type: "singlecheckbox",
      title:
        "I understand that smoking is prohibited within the building and have been shown the designated smoking area for the site.",
      mandatory: true,
    },
    sr7: {
      type: "singlecheckbox",
      title:
        "I understand that eating and drinking is prohibited within the warehouse and that I have been shown the facilities. (Some areas management with allow fluids in the warehouse must be contained in a sealed container)",
      mandatory: true,
    },
    sr8: {
      type: "singlecheckbox",
      title:
        "I understand that I am only permitted to work in my designated work areas as set out by my manager.",
      mandatory: true,
    },
    sr9: {
      type: "singlecheckbox",
      title:
        "I understand that I`m not permitted to enter the vehicle yard, unless this is within my designated work area. Any permitted access should be by the designated walkways.",
      mandatory: true,
    },
    sr10: {
      type: "singlecheckbox",
      title:
        "I will attend work clean and presentable, and while at work be polite and courteous to my colleagues, staff members and the general public.",
      mandatory: true,
    },
  };
  const [fields, setField] = useForm(initialState);
  const woodland = appData.woodlandGroupOnboarding;
  const submitted = woodland && woodland.siteRules;

  const redirectBack = () => {
    history.push("/profile/edit/woodland-group-onboarding");
  };

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    postWoodlandFormsFunc("siteRules", {
      ...fieldValuesPayload,
      date: moment().toISOString(),
    });
    redirectBack();
  };

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"Site Rules"}
          helper={""}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"woodlandBranch"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};

SiteRules.propTypes = {
  appData: any,
  postWoodlandFormsFunc: func,
};

const mapDispatchToProps = {
  postWoodlandFormsFunc: postWoodlandForms,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(SiteRules);
